// Repeated server buys from one panel (the Rynek's animal food): every tap is queued and bought in turn, one request
// at a time, so tapping ten times buys ten. A failed buy (out of coins, offline) drops the rest of that burst. Pure
// (node --test).
//   buy(item) → Promise<boolean>;  onEach(item, ok) after each buy;  onDrain() once the burst is through.
export function createBuyQueue({ buy, onEach = () => {}, onDrain = () => {} }) {
  let chain = Promise.resolve(), pending = 0, failed = false;
  return {
    add(item) {
      if (pending === 0) failed = false;
      pending++;
      chain = chain.then(async () => {
        if (failed) return;
        let ok = false;
        try { ok = !!(await buy(item)); } catch { ok = false; }
        if (!ok) failed = true;
        onEach(item, ok);
      }).finally(() => { if (--pending === 0) onDrain(); });
    },
    idle: () => chain,
    get pending() { return pending; },
  };
}
